module.exports = __webpack_public_path__ + "static/img/shiyiTwo.1ae5dd69.png";